export default (posts) => {
    //Gets the first featured post in Ghost CMS
    if (!posts || posts.length <= 0) return null;
    //find featured post in posts
    const post = posts.find(({ node }) => node && node.featured); //post data in node variable
    //if featured post found then return just the node data
    return post ? post.node : null;
}